import { ChildrenRelationsAspect, Entity } from "@aninix-inc/model";

export const insertToParent = (entity: Entity, parent: Entity, index: number) => {
  const aspect = parent.getAspectOrThrow(ChildrenRelationsAspect)
  aspect.addChild(entity, index)
}
